import axios from 'axios';
import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import extend from 'lodash/extend';
import authUtil from '../utils/auth_util';
import log from '../services/logger_service';

export default class Newsletter {
  static post(args, config) {
    const host = get(config, 'apiEndpoint');
    const protocol = get(config, 'protocol');
    const options = extend({}, args);
    const url = `${protocol}${host}/api/v2/newsletter`;

    // api has auth in beta
    if (get(config, 'authEnabled')) {
      extend(options, authUtil(config, 'post'));
    }

    if (!canUseDOM) {
      log.info(`Requesting: ${url} from model.`);
    }

    return axios.post(url, options);
  }
}



// WEBPACK FOOTER //
// ./src/models/newsletter_module.js